import * as colors from 'material-ui/styles/colors';

require('es6-promise').polyfill();
require('isomorphic-fetch');

export const getKenmei = () => {
  return fetch(`http://localhost:5000/api/kenmei`, {mode: 'cors'})
    .then((res) => { return res.json()})
    .then((json) => {
      return json
    })
}

export const getRoumuEvents = (userId, start, end) => {
  return fetch(`http://localhost:5000/api/roumu/${userId}/${start}/${end}`, {mode: 'cors'})
    .then((res) => { return res.json()})
    .then((json) => {
      return json
    })
}


export const registRoumuEvent = (params) => {

  return fetch('http://localhost:5000/api/roumu', { 
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params),
      mode: 'cors'})
    .then(function(response) { return response.json() })
    .then(function(json) {
      return json
    });

}

export const approvalRoumuEvent = (params) => {

  return fetch('http://localhost:5000/api/roumu/approval', { 
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params),
      mode: 'cors'})
    .then(function(response) { return response.json() })
    .then(function(json) {
      return json
    });

}

export const post = (url, data) => {
  
  const headers = new Headers();
  headers.append('content-type', 'application/json')

  var form = new FormData();
  form.append( "json", JSON.stringify( data ) );

  return fetch(url, { 
      method: 'POST',
      header: headers,
      body: JSON.stringify(data),
      mode: 'corsr'
    })
    .then(function(response) { return response.json() })
    .then(function(json) {
      return json
    }).catch(function(e) {
      return {fetchError: e}
    })

}

export const get = (url, headers = {}) => {
  return fetch(url, {
      mode: 'cors',
      headers: headers
    })
    .then((res) => { return res.json()})
    .then((json) => {
      return json
    }).catch(function(e) {
      return {fetchError: e}
    })
}



export const get2 = (url, headers = {}) => {

  return fetch(url, {
      headers: headers,
      credentials: 'include'
    })
    .then((res) => { return res.json()})
    .then((json) => {
      return json
    }).catch(function(e) {
      return {fetchError: e}
    })
}

export const post2 = (url, data = {}) => {
  
  return fetch(url, { 
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(Object.keys(data).length ? data : {q: 'q'}),
      credentials: 'include'
    })
    .then(function(response) { return response.json() })
    .then(function(json) {
      return json
    }).catch(function(e) {
      return {fetchError: e}
    })

}

export const upload = (url, data) => {

    return fetch(url, {
        method: 'POST',
        body: data,
        credentials: 'include'
    })
        .then(function(response) { return response.json() })
        .then(function(json) {
            return json
        }).catch(function(e) {
            return {fetchError: e}
        })

}

export const put2 = (url, data) => {
  
  return fetch(url, { 
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(Object.keys(data).length ? data : {q: 'q'}),
      credentials: 'include'
    })
    .then(function(response) { return response.json() })
    .then(function(json) {
      return json
    }).catch(function(e) {
      return {fetchError: e}
    })

}

export const delete2 = (url) => {
  
  return fetch(url, { 
      method: 'DELETE',
      credentials: 'include'
    })
    .then(function(response) { return response.json() })
    .then(function(json) {
      return json
    }).catch(function(e) {
      return {fetchError: e}
    })

}

export const dispMoney = (value) => {
  if (!value || value === '') {
    return value
  }
  if (value == 0) {
      return ''
  }

  try {

    const num = Number(new String(value).replace(/,/g, ''))
    if (isNaN(num)) {
      return value
    }

    return num.toLocaleString()

  } catch(e) {
    return value
  }

}

export const convertHarf = (value) => {

    if (!value || value === '') {
        return value
    }

    const convert = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });

    return convert;

    // const convert = value.replace(/[^A-Za-z0-9]/g, '');
    //
    // console.log(convert);
    //
    // return convert;

    // if (/^[A-Za-z0-9]*$/.test(value)) {
    //     return value
    // } else {
    //     return ""
    // }
}

export const dispAvg = (value) => {
    if (!value || value === '') {
        return '-%'
    }
    return value + '%';
}


export const toNumber = (value) => {
  if (!value || value === '') {
    return 0 
  }
  let str = new String(value);
  const number = str.replace(/,/g, '')
  return /^[-]?([1-9]\d*|0)(\.\d+)?$/.test(number) ? Number(number) : 0
}

export const validateNumber = (value) => {

  if (!value || value === '') {
    return false
  }

  let str = new String(value);
  const number = str.replace(/,/g, '')

  return /^[-]?([1-9]\d*|0)(\.\d+)?$/.test(number) ? true : false

}

export const validateTime = (value) => {

  if (!value || value === '') {
    return false
  }

  return /^([01]?[0-9]|2[0-9]):([0-5][0-9])$/.test(value);

}

export const toTimeNumber = (value) => {

  if (!value || value === '') {
    return 0
  }

  return new Number(value.replace(':', ''))

}

export const minutesToHour = (time) => {
    const timeHours = Math.floor(time / 60)
    const timeMinutes = time % 60

    let result = timeHours
    if (timeMinutes != 0) {
        result += '.' + timeMinutes
    }

    return result
}

export const rowColor = (index) => {
    return index % 2 == 0 ? '' : colors.grey50
}


// WEBPACK FOOTER //
// ./src/commons/index.js